export enum DocumentStatusEnum {
  DRAFT = 'DRAFT',
  SIGNING = 'SIGNING',
  REJECTED = 'REJECTED',
  SIGNED = 'SIGNED',
  DELETED = 'DELETED',
  REVOKED = 'REVOKED',
}
